export const GoalsRevenueImage = () => {
  return (
    <svg
      width="267"
      height="257"
      viewBox="0 0 267 257"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M141.173 203.8C197.338 203.8 242.872 158.266 242.872 101.9C242.872 45.5341 197.138 0 141.173 0C85.0074 0 39.4733 45.5341 39.4733 101.9C39.4733 158.266 85.0074 203.8 141.173 203.8Z"
        fill="#EAEEF9"
      />
      <path
        d="M249.191 167.647C253.733 167.647 257.415 163.965 257.415 159.423C257.415 154.881 253.733 151.199 249.191 151.199C244.649 151.199 240.967 154.881 240.967 159.423C240.967 163.965 244.649 167.647 249.191 167.647Z"
        fill="#EAEEF9"
      />
      <path
        d="M261.226 135.553C264.328 135.553 266.843 133.038 266.843 129.936C266.843 126.834 264.328 124.32 261.226 124.32C258.124 124.32 255.61 126.834 255.61 129.936C255.61 133.038 258.124 135.553 261.226 135.553Z"
        fill="#EAEEF9"
      />
      <path
        d="M44.889 34.9029C47.9909 34.9029 50.5055 32.3883 50.5055 29.2863C50.5055 26.1844 47.9909 23.6698 44.889 23.6698C41.7871 23.6698 39.2725 26.1844 39.2725 29.2863C39.2725 32.3883 41.7871 34.9029 44.889 34.9029Z"
        fill="#EAEEF9"
      />
      <path
        d="M10.588 143.222C16.3487 143.222 21.0187 138.552 21.0187 132.791C21.0187 127.03 16.3487 122.36 10.588 122.36C4.82728 122.36 0.157288 127.03 0.157288 132.791C0.157288 138.552 4.82728 143.222 10.588 143.222Z"
        fill="#EAEEF9"
      />
      <path
        d="M214.405 94.5811C214.491 94.2846 214.926 94.2846 215.012 94.5811V94.582L216.644 99.9863V99.9873C216.692 100.161 216.82 100.288 216.993 100.336L222.412 101.97H222.413C222.709 102.056 222.709 102.49 222.413 102.576H222.412L216.993 104.209C216.824 104.255 216.694 104.38 216.658 104.556L215.024 109.977V109.978C214.938 110.274 214.504 110.274 214.418 109.978V109.977L212.784 104.556C212.736 104.383 212.608 104.256 212.435 104.209L207.017 102.576H207.016C206.72 102.49 206.72 102.056 207.016 101.97H207.017L212.426 100.336L212.425 100.335C212.597 100.287 212.725 100.16 212.772 99.9873L212.771 99.9863L214.405 94.582V94.5811Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M187.711 32.3223C187.797 32.0258 188.231 32.0258 188.317 32.3223V32.3232L189.95 37.7275V37.7285C189.997 37.9011 190.125 38.0283 190.297 38.0762V38.0771L195.718 39.7109H195.719C196.015 39.7971 196.015 40.2302 195.719 40.3164L195.718 40.3174L190.299 41.9502C190.13 41.9963 190 42.1209 189.964 42.2959L188.33 47.7168V47.7178C188.244 48.0142 187.81 48.0142 187.724 47.7178V47.7168L186.09 42.2959C186.048 42.1456 185.945 42.0299 185.805 41.9717L185.741 41.9502L180.323 40.3174L180.322 40.3164C180.026 40.2302 180.026 39.7971 180.322 39.7109H180.323L185.732 38.0771L185.731 38.0762C185.903 38.0285 186.031 37.9014 186.078 37.7285L186.077 37.7275L187.711 32.3232V32.3223Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M100.76 63.2852C100.832 63.0383 101.194 63.0382 101.266 63.2852V63.2861L102.694 68.0146V68.0156C102.737 68.1707 102.851 68.2849 103.006 68.3281V68.3291L107.749 69.7588H107.75C107.997 69.8306 107.997 70.1928 107.75 70.2646L107.749 70.2656L103.009 71.6943C102.873 71.7313 102.764 71.8246 102.719 71.957L102.706 72.0059L101.276 76.748V76.749C101.205 76.9964 100.842 76.9964 100.771 76.749V76.748L99.3409 72.0059H99.3399C99.2968 71.8511 99.1826 71.7367 99.0274 71.6943H99.0264L94.2862 70.2656L94.2852 70.2646C94.0384 70.1925 94.0383 69.8308 94.2852 69.7588H94.2862L99.0157 68.3291L99.0167 68.3301C99.1725 68.2874 99.2876 68.1716 99.3301 68.0156L99.3292 68.0146L100.759 63.2861L100.76 63.2852Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M67.2757 130.07C67.3785 130.07 67.4888 130.136 67.5276 130.289V130.29L68.9564 135.695V135.695C68.9963 135.863 69.1065 135.994 69.265 136.045V136.046L74.0081 137.68H74.0101C74.1285 137.719 74.1984 137.842 74.1985 137.984C74.1985 138.126 74.1286 138.249 74.0101 138.288H74.0081L69.2679 139.921C69.1112 139.97 68.9986 140.1 68.9681 140.27L67.5384 145.691V145.692C67.4995 145.845 67.3893 145.911 67.2864 145.911C67.1836 145.911 67.0733 145.845 67.0345 145.692V145.691L65.6048 140.27H65.6038C65.563 140.102 65.4526 139.971 65.2933 139.921L60.553 138.288H60.5521C60.4334 138.249 60.3626 138.126 60.3626 137.984C60.3628 137.842 60.4335 137.719 60.5521 137.68H60.553L65.2855 136.046L65.2845 136.045C65.4435 135.995 65.554 135.863 65.5941 135.695L65.5931 135.695L67.0228 130.29V130.289C67.0616 130.136 67.1728 130.07 67.2757 130.07Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M60.1057 72.1733C60.149 72.0241 60.369 72.0241 60.4123 72.1733V72.1743L61.4328 75.5503V75.5513C61.4658 75.6723 61.556 75.7622 61.6769 75.7954L65.0627 76.8159L65.0637 76.8169C65.2129 76.8602 65.2129 77.0802 65.0637 77.1235H65.0627L61.675 78.144C61.5595 78.1763 61.4682 78.2631 61.4416 78.3853L60.4201 81.7729V81.7739C60.3768 81.9231 60.1568 81.9231 60.1135 81.7739V81.7729L59.092 78.3853C59.0584 78.2659 58.9695 78.1771 58.8498 78.144H58.8508L55.4631 77.1235H55.4621C55.3129 77.0802 55.313 76.8603 55.4621 76.8169L55.4631 76.8159L58.84 75.7954L58.841 75.7964C58.9621 75.7633 59.0521 75.6724 59.0851 75.5513L59.0842 75.5503L60.1057 72.1743V72.1733Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M174.856 129.212C174.899 129.063 175.119 129.063 175.162 129.212V129.213L176.183 132.589V132.59C176.216 132.711 176.306 132.801 176.427 132.834L179.813 133.854L179.814 133.855C179.963 133.899 179.963 134.119 179.814 134.162H179.813L176.425 135.183C176.309 135.215 176.218 135.302 176.191 135.424L175.17 138.812V138.812C175.127 138.962 174.907 138.962 174.863 138.812V138.812L173.842 135.424C173.808 135.304 173.719 135.216 173.6 135.183H173.601L170.213 134.162H170.212C170.063 134.119 170.063 133.899 170.212 133.855L170.213 133.854L173.59 132.834L173.591 132.835C173.712 132.802 173.802 132.711 173.835 132.59L173.834 132.589L174.856 129.213V129.212Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M124.939 10.2209C124.983 10.0717 125.203 10.0717 125.246 10.2209V10.2219L126.266 13.5978V13.5988C126.299 13.7199 126.39 13.8098 126.51 13.843L129.896 14.8635L129.897 14.8644C130.046 14.9078 130.046 15.1278 129.897 15.1711H129.896L126.509 16.1916C126.393 16.2239 126.302 16.3107 126.275 16.4328L125.254 19.8205V19.8215C125.21 19.9707 124.99 19.9707 124.947 19.8215V19.8205L123.926 16.4328C123.892 16.3134 123.803 16.2246 123.683 16.1916H123.684L120.297 15.1711H120.296C120.146 15.1278 120.147 14.9078 120.296 14.8644L120.297 14.8635L123.674 13.843L123.675 13.8439C123.796 13.8108 123.886 13.72 123.919 13.5988L123.918 13.5978L124.939 10.2219V10.2209Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M205.221 155.35C205.265 155.201 205.485 155.201 205.528 155.35V155.351L206.549 158.727V158.728C206.582 158.849 206.672 158.939 206.793 158.972L210.179 159.992L210.18 159.993C210.329 160.037 210.329 160.257 210.18 160.3H210.179L206.791 161.32C206.675 161.353 206.584 161.44 206.557 161.562L205.536 164.949V164.95C205.493 165.1 205.273 165.1 205.229 164.95V164.949L204.208 161.562C204.174 161.442 204.085 161.353 203.966 161.32H203.967L200.579 160.3H200.578C200.429 160.257 200.429 160.037 200.578 159.993L200.579 159.992L203.956 158.972L203.957 158.973C204.078 158.94 204.168 158.849 204.201 158.728L204.2 158.727L205.221 155.351V155.35Z"
        fill="#ADB6C8"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M104.669 114.268L104.667 114.281L104.668 114.295L104.668 114.297C104.668 114.298 104.668 114.3 104.669 114.302L104.676 114.396C104.682 114.462 104.69 114.56 104.699 114.688C104.719 114.944 104.745 115.318 104.774 115.79C104.831 116.734 104.898 118.073 104.934 119.647C105.005 122.797 104.951 126.89 104.455 130.668C104.207 132.556 103.85 134.364 103.342 135.935C102.834 137.507 102.178 138.835 101.34 139.77C100.504 140.702 99.4866 141.243 98.2468 141.249C97.0025 141.254 95.5189 140.721 93.7536 139.474C85.3523 133.541 77.5524 132.774 72.5693 133.143C71.671 133.21 70.7877 132.683 70.2418 131.93C69.696 131.178 69.5058 130.227 69.9516 129.455L77.9116 115.668C79.8707 112.274 84.3804 110.017 89.7396 108.47C95.0465 106.937 101.158 106.109 106.375 105.551L104.669 114.268Z"
        fill="#7647EE"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M160.181 136.615C162.277 141.465 164.615 147.173 165.949 152.523C167.296 157.924 167.611 162.931 165.652 166.325L157.692 180.112C157.246 180.884 156.328 181.195 155.404 181.099C154.479 181.002 153.58 180.5 153.189 179.689C151.017 175.189 146.453 168.818 137.115 164.509C135.152 163.603 133.949 162.585 133.331 161.505C132.716 160.428 132.676 159.277 133.065 158.087C133.456 156.893 134.278 155.661 135.385 154.435C136.492 153.21 137.878 151.996 139.39 150.837C142.414 148.519 145.932 146.427 148.695 144.913C150.077 144.157 151.269 143.545 152.115 143.122C152.539 142.911 152.876 142.747 153.107 142.636C153.223 142.581 153.312 142.539 153.372 142.511L153.457 142.47C153.459 142.469 153.461 142.468 153.462 142.468L153.462 142.467L153.476 142.461L153.486 142.453L160.181 136.615Z"
        fill="#7647EE"
        stroke="black"
        strokeWidth="0.2"
      />
      <g filter="url(#filter0_d_35_10160)">
        <path
          d="M176.934 45.348C157.275 47.2255 126.525 61.9775 111.671 94.7728C96.7122 127.507 90.5154 144.334 94.0818 151.318C97.7538 158.363 102.965 162.498 107.715 165.24C112.464 167.982 118.65 170.428 126.588 170.085C134.525 169.743 145.893 155.902 166.762 126.58C187.632 97.2575 185.032 63.2508 176.934 45.348Z"
          fill="url(#paint0_linear_35_10160)"
        />
        <path
          d="M176.872 45.4543C184.934 63.3464 187.502 97.2678 166.681 126.522C156.247 141.183 148.19 151.969 141.752 159.133C138.532 162.715 135.72 165.387 133.22 167.185C130.72 168.983 128.54 169.901 126.583 169.985C118.671 170.327 112.503 167.888 107.764 165.153C103.026 162.417 97.8305 158.294 94.17 151.271C93.2913 149.55 93.009 147.211 93.3212 144.149C93.6333 141.088 94.5391 137.315 96.0247 132.732C98.8103 124.14 103.631 112.718 110.386 97.8374L111.762 94.8141C126.581 62.0953 157.241 47.3578 176.872 45.4543Z"
          stroke="black"
          strokeWidth="0.2"
        />
      </g>
      <g filter="url(#filter1_d_35_10160)">
        <path
          d="M115.77 175.66L94.6625 163.473C92.9739 162.498 92.4995 160.395 93.4135 158.812L96.3992 153.641L123.523 169.3L120.598 174.366C119.517 175.994 117.353 176.574 115.77 175.66Z"
          fill="url(#paint1_linear_35_10160)"
        />
        <path
          d="M123.387 169.337L120.514 174.312C119.46 175.9 117.353 176.458 115.82 175.573L94.7126 163.386C93.074 162.44 92.6123 160.399 93.4997 158.862L96.4357 153.777L123.387 169.337Z"
          stroke="black"
          strokeWidth="0.2"
        />
      </g>
      <path
        d="M135.623 120.114L113.239 158.885L110.456 157.279L132.84 118.508L135.623 120.114Z"
        fill="url(#paint2_linear_35_10160)"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M146.529 98.0118C152.299 101.343 159.678 99.3662 163.009 93.5958C166.341 87.8254 164.364 80.4467 158.594 77.1152C152.823 73.7836 145.444 75.7607 142.113 81.5311C138.781 87.3016 140.758 94.6802 146.529 98.0118Z"
        stroke="#9FA8BA"
        strokeWidth="8.02363"
        strokeMiterlimit="10"
      />
      <path
        d="M101.475 173.854C109.975 178.761 112.798 189.626 107.951 198.022C105.489 202.286 96.3611 214.14 86.7779 224.311C81.987 229.396 77.0865 234.056 72.8524 237.136C70.735 238.676 68.7887 239.818 67.1097 240.421C65.4283 241.025 64.0346 241.082 63.004 240.487C61.9736 239.892 61.3271 238.657 61.0095 236.899C60.6923 235.143 60.7075 232.887 60.9826 230.283C61.5328 225.076 63.1181 218.503 65.1265 211.811C69.1437 198.426 74.8444 184.594 77.3065 180.33C82.2144 171.829 92.9741 168.946 101.475 173.854Z"
        fill="#FD561F"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M95.6865 183.88C99.2269 185.924 100.46 190.525 98.4156 194.065C96.7455 196.958 92.4377 202.411 87.681 207.756C83.0079 213.007 77.9112 218.136 74.4722 220.622C74.8779 216.451 76.7716 209.474 78.9893 202.791C81.2472 195.986 83.8312 189.502 85.5013 186.609C87.5454 183.069 92.146 181.836 95.6865 183.88Z"
        fill="#FDEFD8"
        stroke="black"
        strokeWidth="0.2"
      />
      <defs>
        <filter
          id="filter0_d_35_10160"
          x="48.9686"
          y="23.283"
          width="178.063"
          height="213.029"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="22.065" />
          <feGaussianBlur stdDeviation="22.065" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_35_10160"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_35_10160"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_35_10160"
          x="48.8259"
          y="131.576"
          width="118.827"
          height="110.712"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="22.065" />
          <feGaussianBlur stdDeviation="22.065" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_35_10160"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_35_10160"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_35_10160"
          x1="178.505"
          y1="42.5575"
          x2="106.939"
          y2="166.515"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_10160"
          x1="110.061"
          y1="161.278"
          x2="105.21"
          y2="169.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_35_10160"
          x1="133.501"
          y1="120.578"
          x2="120.881"
          y2="142.437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
